import {useEffect, useState} from "react";
import {Link, useMatch, useNavigate, useSearchParams} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {Registration} from "./Registration";
import {SignIn} from "./SignIn";
import {Typography} from "@shared/ui/Typography/Typography";
import {sessionStore} from "@services/session";
import styles from "./Login.module.scss";

export const Login = observer(() => {

    const navigate = useNavigate()
    const param = useMatch(`*`)?.params["*"]?.split('/').shift()

    const {isAuth} = sessionStore

    // useEffect(() => {
    //     if (isAuth) {
    //         navigateObserver('/')
    //     }
    // }, [isAuth]);

    return (
        <div className={styles.root}>

            {param === 'login' &&
                <SignIn/>
            }
            {param === 'registration' &&
                <Registration/>
            }

            {/*<Typography>*/}
            {/*    <Typography type={"span"} align={'center'}>*/}
            {/*        {param === 'login' ? `Нет аккаунта? ` : 'Есть аккаунт? '}*/}
            {/*    </Typography>*/}
            {/*    <Link to={param === 'login' ? `/registration${key ? `?key=${key}` : ''}` : '/login'}>*/}
            {/*        <Typography type={"span"} fontWeight={"bold"} align={'center'}>*/}
            {/*            {param === 'login' ? `Зарегистрируйтесь`: 'Войти'}*/}
            {/*        </Typography>*/}
            {/*    </Link>*/}
            {/*</Typography>*/}

        </div>
    )
})